export default class UserGroupRequests {
    constructor(appmixerApi) {
        this.api = appmixerApi;
    }

    queryUserGroups(query = {}) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/user-groups`,
            method: 'GET',
            params: query
        });
    }

    queryUserGroup(groupId) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/user-groups/${groupId}`,
            method: 'GET'
        });
    }

    addUserToGroup(groupId, userId) {
        return this.api.request({
            url: `${this.api.get('baseUrl')}/user-groups/${groupId}/members`,
            method: 'POST',
            data: { userIds: [userId] }
        });
    }
}
